export enum PaymentMethodsAnaliticaEnum {
  CREDIT_CARD = 'cartão de crédito',
  INVOICE = 'boleto',
  PIX = 'pix',
}
export enum LangTypeAnaliticaEnum {
  EN = 'en',
  PT = 'pt',
  ES = 'es',
}

 export enum StatusTypeAnaliticaEnum {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum Status3DSTypeAnaliticaEnum {
  HABILITADO = 'habilitado',
  DESABILITADO = 'desabilitado',
}

export enum DigitalWalletsTypeAnaliticaEnum {
  APPLE_PAY = 'Apple Pay',
  GOOGLE_PAY = 'Google Pay',
  CLICK_TO_PAY = 'Click to pay',
}

export enum DigitalWalletsStatusTypeAnaliticaEnum {
  SUCCESS = StatusTypeAnaliticaEnum.SUCCESS,
  ERROR = StatusTypeAnaliticaEnum.ERROR,
  DESISTENCIA = 'desistência',
}

export enum ValidationPropertiesTypeAnaliticaEnum {
  HABILITADO = 'habilitado',
  DESABILITADO = 'desabilitado',
  APPLE_PAY = DigitalWalletsTypeAnaliticaEnum.APPLE_PAY,
  GOOGLE_PAY = DigitalWalletsTypeAnaliticaEnum.GOOGLE_PAY,
  CLICK_TO_PAY = DigitalWalletsTypeAnaliticaEnum.CLICK_TO_PAY,
}

export enum DigitalWallets {
  APPLE_PAY = DigitalWalletsTypeAnaliticaEnum.APPLE_PAY,
  GOOGLE_PAY = DigitalWalletsTypeAnaliticaEnum.GOOGLE_PAY,
  CLICK_TO_PAY = DigitalWalletsTypeAnaliticaEnum.CLICK_TO_PAY,
}

export enum PaymentMethodsTypeAnaliticaEnum {
  CREDIT_CARD = PaymentMethodsAnaliticaEnum.CREDIT_CARD,
  INVOICE = PaymentMethodsAnaliticaEnum.INVOICE,
  PIX = PaymentMethodsAnaliticaEnum.PIX,
}

export enum FlowErrorStatusTypeAnaliticaEnum {
  ERRO_400 = 'erro 400',
  ERRO_404 = 'erro 404',
  ERRO_500 = 'erro 500',
  ERRO_GENERICO = 'erro genérico',
}
